import { CustomSettingsIcon, GlobalSettingsIcon } from '@reveni-io/reveni-ui'

import { settingsTypes } from '@/configuration/constants'

export const options = [
  { label: 'Usar configuración global', value: settingsTypes.global, icon: <GlobalSettingsIcon size={16} /> },
  { label: 'Usar configuración personalizada', value: settingsTypes.custom, icon: <CustomSettingsIcon size={16} /> },
]
